export const ACCESS_RIGHTS = {

  //#region CORE
  CORE_SECURITY_USERS: 1001,
  CORE_SECURITY_ROLES: 1002,
  CORE_SECURITY_AUDITLOGS: 1003,
  CORE_TRANSACTIONS_ACCESSREQUESTS_VIEWER: 1004,
  CORE_TRANSACTIONS_ACCESSREQUESTS_REQUESTOR: 1005,
  CORE_TRANSACTIONS_ACCESSREQUESTS_APPROVER: 1006,
  //#endregion
  
  //#region GLOBO ASIATICO
  GLOBO_PATIENTS: 8101,
  GLOBO_PATIENTS_PROGRAMS: 8102,
  GLOBO_PATIENTS_PRESCRIPTIONS: 8103,
  GLOBO_PATIENTS_FILES: 8104,
  GLOBO_PATIENTS_LOGS: 8105,

  GLOBO_STATICDATA_DIAGNOSIS: 8501,
  GLOBO_STATICDATA_DOCTORS: 8502,
  GLOBO_STATICDATA_DROPOUTREASONS: 8503,
  GLOBO_STATICDATA_HOSPITALS: 8504,
  GLOBO_STATICDATA_PATIENTSEGMENTS: 8505,
  GLOBO_STATICDATA_PRINCIPALS: 8506,
  GLOBO_STATICDATA_PRODUCTS: 8507,
  GLOBO_STATICDATA_PROGRAMS: 8508,
  GLOBO_STATICDATA_PURCHASINGACCOUNTS: 8509,
  GLOBO_STATICDATA_THERAPEUTICAREAS: 8510,
  GLOBO_STATICDATA_UOMS: 8511,

  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_VIEWER: 8601,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_REQUESTOR: 8602,
  GLOBO_TRANSACTIONS_DOCTORENROLLMENTS_APPROVER: 8603,

  GLOBO_TRANSACTIONS_LOAREQUESTS_VIEWER: 8604,
  GLOBO_TRANSACTIONS_LOAREQUESTS_REQUESTOR: 8605,
  GLOBO_TRANSACTIONS_LOAREQUESTS_APPROVER: 8606,

  GLOBO_TRANSACTIONS_ORDERREQUESTS_VIEWER: 8607,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_REQUESTOR: 8608,
  GLOBO_TRANSACTIONS_ORDERREQUESTS_APPROVER: 8609,

  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_VIEWER: 8610,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_REQUESTOR: 8611,
  GLOBO_TRANSACTIONS_PATIENTENROLLMENTS_APPROVER: 8612,
  
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_VIEWER: 8613,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_REQUESTOR: 8614,
  GLOBO_TRANSACTIONS_PRESCRIPTIONREQUESTS_APPROVER: 8615,
  //#endregion GLOBO ASIATICO
};
